import { render, staticRenderFns } from "./RideHailingDetails.vue?vue&type=template&id=3b53a3aa&"
import script from "./RideHailingDetails.vue?vue&type=script&lang=js&"
export * from "./RideHailingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports